import { AfterContentChecked, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from 'libs/core/src/lib/service/app.service';
import { HeaderService } from 'libs/core/src/lib/service/header.service';
import { NavigationHelperService } from 'libs/core/src/lib/service/navigation/navigation-helper.service';
import { VoucherService } from 'libs/core/src/lib/service/voucher.service';
import { AuthStateService } from 'libs/core/src/lib/state/auth.state.service';
import { CateringStateService } from 'libs/core/src/lib/state/catering.state.service';
import { OrderStateService } from 'libs/core/src/lib/state/order.state.service';
import { HeaderComponent } from 'libs/shared/src/lib/component/layout/header/header.component';
import { CinemaDataProvider } from 'libs/core/src/lib/data-provider/cinema.data-provider';
import { ScreenStateService } from 'libs/core/src/lib/state/screen.state.service';
import { FlowType, NavigationService } from '@lib/core';
import { FlowService } from 'libs/core/src/lib/service/flow.service';

@Component({ standalone: false, selector: 'app-header', templateUrl: './header.component.html' })
export class CustomHeaderComponent extends HeaderComponent implements OnInit, AfterContentChecked, OnDestroy {
  env = environment;

  public flowType: FlowType = null;
  public flowTypeEnum: typeof FlowType = FlowType;

  constructor(
    protected orderStateService: OrderStateService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected translateService: TranslateService,
    protected navigationHelperService: NavigationHelperService,
    protected headerService: HeaderService,
    protected voucherService: VoucherService,
    protected authService: AuthStateService,
    protected cateringStateService: CateringStateService,
    protected appService: AppService,
    protected cinemaDataProvider: CinemaDataProvider,
    protected screenStateService: ScreenStateService,
    protected navigationService: NavigationService,
    protected flowService: FlowService
  ) {
    super(
      environment,
      orderStateService,
      router,
      route,
      translateService,
      navigationHelperService,
      headerService,
      voucherService,
      authService,
      cateringStateService,
      appService,
      cinemaDataProvider,
      screenStateService,
      navigationService
    );

    flowService.flowType$.subscribe((flowType) => {
      this.flowType = flowType;
    });
  }
}
